import * as $ from 'jquery';
import { Component, OnInit, HostListener, ViewChild, AfterViewInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonService } from './../../../services/common/common.service';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../constants/master-constants';
import { tableHeader } from '../../../models/AccountDetailsVM';
import { LoaderService } from './../../../services/infrastructure/loader.service';
import { SliderModelService } from './../../../services/infrastructure/sliderModel.service';
import { ToastrService } from 'ngx-toastr';
import { GrowerSearchFilter, dashboradDDL, GrowerError, apiResponse } from '../../../models/GrowerListing';
import { Subscription } from 'rxjs';
import { LolLoggerService } from './../../../common/shared/lol-logger.service';
import { MessageConfigurationVM } from '../../../models/MessageConfigurationVM';

@Component({
  selector: 'app-grower-search',
  templateUrl: './grower-search.component.html',
  styleUrls: ['./grower-search.component.scss']
})

export class GrowerSearchComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  private subscription = new Array<Subscription>();
  // used to identify is search component is used as a nested component in slider
  @Input()
  usedAsNestedComp = false;

  @Input() GrowerSearchSliderActive = false;
  // input for selected account number
  // @Input('accountNumber') accountNumber: number;

  // set table header data
  headerList: tableHeader[] = [];

  // for addGrower and add Grower button div show/hide
  addGrower = false;
  enableAddGrower = false;

  // header company code and crop year
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;

  // error msg
  enableErrorMsg = false;
  ErrorMessage = '';

  // Table DS
  growerDS: any[] = [];
  ApiData: any[] = [];

  // state Data Source
  stateDS: any[];

  // filter
  filterArray: any[] = [];

  // account drop down
  accountLoading: boolean;
  accountDataCount: number;

  // Account Data Source
  accountSearchData: any[] = [];

  // used as a model for search grower form
  brwModel = new GrowerSearchFilter();

  // used as a error model for search grower form
  brwErrorModel = new GrowerError();

  clearFtr = false;

  growerSearchNotFoundMessage = '';
  growerSearchType = '';

  constructor(private commonService: CommonService,
    private localStorageService: LocalStorageService,
    private sliderModelService: SliderModelService,
    private toastrService: ToastrService,
    private loaderService: LoaderService) {
    this.headerList = [
      { headertxt: 'Grower', columnfield: 'grower', className: 'mat-header-cell accountId' },
      { headertxt: 'Phone', columnfield: 'phoneNo', className: 'mat-header-cell accountName' },
    ];

    // Set the default value for crop year
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
    this.addGrower = false;

    // set properties of Model
    this.brwModel.ABNumber = 0;
    this.brwModel.BusinessName = '';
    this.brwModel.City = '';
    this.brwModel.Email = '';
    this.brwModel.FirstName = '';
    this.brwModel.GLN = '';
    this.brwModel.GrowerCode = '';
    this.brwModel.LastName = '';
    this.brwModel.State = null;
  }

  ngOnInit() {
    // set grid's client side column filter
    this.filterArray = [

      { label: 'Name', column: 'name' },
      { label: 'Address', column: 'address' },
      { label: 'City', column: 'city' },
      { label: 'State / Province', column: 'state' },
      { label: 'Zip', column: 'zip' },
      { label: 'Phone', column: 'phoneNo' }];
    // get default Account No
    this.subscription.push(this.sliderModelService.toAccountNumber.subscribe(data => {
      // get all drop down data
      this.getDropDownData();
      this.brwModel.ABNumber = data;
    }));

    this.subscription.push(this.sliderModelService.growerSearchType.subscribe(searchType => {
      this.growerSearchType = searchType;
    }));

    this.getGrowerSearchNotFoundMessage();
  }

  ngOnChanges() {
    this.clearFilter();
  }

  // get Account and State drop down data from database
  getDropDownData() {
    if (this.headerCompany && this.headerYear) {
      this.subscription.push(this.commonService.getGrowerSearchData().subscribe(result => {
        const data = result as dashboradDDL;
        this.accountSearchData = data.accounts as any[];
        this.accountDataCount = this.accountSearchData.length;
        this.stateDS = data.states as any[];
      }, error => LolLoggerService.error(error)));
    }
  }

  // Validation search criteria
  validateSearchInput() {
    let result = false;

    // set validation pass true
    if ((this.brwModel.BusinessName && (this.brwModel.BusinessName.trim() != '')) ||
      ((this.brwModel.FirstName && this.brwModel.FirstName.trim() != '') && (this.brwModel.LastName && this.brwModel.LastName.trim() != '')) ||
      ((this.brwModel.City && this.brwModel.City.trim() != '') && (this.brwModel.State != null && this.brwModel.State && this.brwModel.State.trim() != '')) ||
      ((this.brwModel.GrowerCode && this.brwModel.GrowerCode.trim() != '') && (this.brwModel.ABNumber && this.brwModel.ABNumber != 0)) ||
      (this.brwModel.GLN && this.brwModel.GLN.trim() != '')) {
      this.enableErrorMsg = false;
      this.ErrorMessage = '';
      result = false;
      this.setError(false, false, false, false, false, false, false, false);
    }
    else {
      if ((this.brwModel.City == '' && (this.brwModel.State != null && this.brwModel.State && this.brwModel.State != '')) ||
        (this.brwModel.City != '' && !this.brwModel.State)) {
        this.enableErrorMsg = true;
        this.ErrorMessage = 'City and State is required when searching by City or State';
        result = true;

        this.setError(false, false, false, false, (this.brwModel.City == ''), (this.brwModel.State == '' || !this.brwModel.State), false, false);
      }
      else if ((this.brwModel.FirstName != '' && this.brwModel.LastName == '') ||
        (this.brwModel.FirstName == '' && this.brwModel.LastName != '')) {
        this.enableErrorMsg = true;
        this.ErrorMessage = 'First and Last Name is required when searching by First or Last Name';
        result = true;
        // this.setError(true, true, false, false, false, false, false, false);
        this.setError((this.brwModel.FirstName == ''), (this.brwModel.LastName == ''), false, false, false, false, false, false);
      }
      else if ((this.brwModel.GrowerCode && this.brwModel.GrowerCode.trim() == '') && (this.brwModel.ABNumber && this.brwModel.ABNumber != 0)) {
        this.enableErrorMsg = false;
        this.ErrorMessage = '';
        result = false;
        this.setError(false, false, false, false, false, false, false, false);
      }
    }
    return result;
  }

  setError(FirstName: boolean, LastName: boolean, BusinessName: boolean, GLN: boolean, City: boolean, State: boolean,
    ABNumber: boolean, GrowerCode: boolean) {
    this.brwErrorModel.FirstName = FirstName;
    this.brwErrorModel.LastName = LastName;
    this.brwErrorModel.BusinessName = BusinessName;
    this.brwErrorModel.GLN = GLN;
    this.brwErrorModel.City = City;
    this.brwErrorModel.State = State;
    this.brwErrorModel.ABNumber = ABNumber;
    this.brwErrorModel.GrowerCode = GrowerCode;
  }

  // Added validation to check length of fields >2
  lengthValidation(field: string, value: string) {
    if (value.length < 3 && value != '') {
      this.enableErrorMsg = true;
      this.ErrorMessage = 'Please enter a minimum of 3 characters in a field';

      switch (field) {
        case 'FirstName':
          this.brwErrorModel.FirstName = true;
          break;
        case 'LastName':
          this.brwErrorModel.LastName = true;
          break;
        case 'BusinessName':
          this.brwErrorModel.BusinessName = true;
          break;
      }
    }
    else {
      // set displayed message false
      this.enableErrorMsg = false;
      this.brwErrorModel.FirstName = false;
      this.brwErrorModel.LastName = false;
      this.brwErrorModel.BusinessName = false;
    }
  }

  validateOnFocusOut(ctrlName: any, value: any) {
    if (value != '') {
      switch (ctrlName) {
        case 'city':
          this.brwErrorModel.City = false;
          break;
        case 'state':
          this.brwErrorModel.State = false;
          break;
        case 'gln':
          this.brwErrorModel.GLN = false;
          break;
      }
    }
  }

  // Converting result data into Grower Name and Phone no column and the assign it to grower Data source
  convertToPass(dataList: any[]) {
    // declare and initialize an array
    const convertedList = [];

    // Null check
    if (dataList != null) {
      // lop through data
      dataList.forEach(x => {
        // Null check
        if (x) {
          // get businessName, if null then firstName and lastName
          const businessName = x.businessName ? x.businessName : '';
          const name = (x.firstName ? x.firstName + ' ' : '') + (x.lastName ? x.lastName : '');

          // address Txt and phone no
          const addresstxt = x != null ? x.address1 + ' ' + x.city + ' ' + x.state + ' ' + x.zip : '';
          const phoneNumber = x.phoneNumber;

          // adding grid type object into array
          let html = '';
          if (businessName === '') {
            html = '<p class="grower-name"><a>' + name + '</a></p><p> ' + addresstxt + '</p>';
          }
          else if (name === '') {
            html = '<p class="grower-name"><a>' + businessName + '</a></p><p> ' + addresstxt + '</p>';
          }
          else {
            html = '<p class="grower-name"><a>' + businessName + '</a></p><p>' + name + '</p><p> ' + addresstxt + '</p>';
          }

          convertedList.push({
            gmk: x.gmk,
            growerInnerHtml: html,
            phoneNo: phoneNumber,
          });
        }
      });
    }
    return convertedList;
  }

  // filter method called on filter's textbox enter
  filterGrid(e: any) {
    // e : contain filter data and Null check
    if (e) {
      // get all values in local variables
      const phoneNo = e.phoneNo;
      const name = e.name;
      const address = e.address;
      const state = e.stateId;
      const city = e.city;
      const zip = e.zip;

      // search data on Api data get the result
      const result = this.ApiData.filter(x => {
        // Null check
        if (x) {
          // get data for address, city , state and Zip
          var xAddress = x.address1;
          var xCity = x.city;
          var xZip = x.zip;
          var xState = x.state;
          var xPhoneNo = x.phoneNumber;
        }

        // check row values on filter data
        return (
          ((name ? (x.businessName && x.businessName.toLowerCase().indexOf(name.toLowerCase()) !== -1) : true) ||
            (name ? (x.firstName && x.firstName.toLowerCase().indexOf(name.toLowerCase()) !== -1) : true) ||
            (name ? (x.firstName && x.lastName.toLowerCase().indexOf(name.toLowerCase()) !== -1) : true)) &&
          (address ? (xAddress && xAddress.toLowerCase().indexOf(address.toLowerCase()) !== -1) : true) &&
          (phoneNo ? (xPhoneNo && xPhoneNo.toLowerCase().indexOf(phoneNo.toLowerCase()) !== -1) : true) &&
          (city ? (xCity && xCity.toLowerCase().indexOf(city.toLowerCase()) !== -1) : true) &&
          (zip ? (xZip && xZip.toLowerCase().indexOf(zip.toLowerCase()) !== -1) : true) &&
          (state ? (xState && xState.toLowerCase().indexOf(state.toLowerCase()) !== -1) : true)
        );
      });

      // converted data into Grower Name and Phone no column and the assign it to grower Data source
      this.growerDS = this.convertToPass(result);
    }
    else {
      // converted data into Grower Name and Phone no columns and the assign it to grower Data source
      this.growerDS = this.convertToPass(this.ApiData);
    }
  }

  // reteriving grower search result from XSInc
  searchGrower(searchGrowerForm: NgForm) {
    // added for bug : 41569
    if (this.brwModel.BusinessName == '' && this.brwModel.City == '' && this.brwModel.Email == '' && this.brwModel.FirstName == '' && this.brwModel.GLN == '' &&
      this.brwModel.GrowerCode == '' && this.brwModel.LastName == '' && this.brwModel.State == null) {
      this.enableErrorMsg = true;
      this.ErrorMessage = 'Add more search parameter';
      return false;
    }
    else {
      this.enableErrorMsg = false;
      this.ErrorMessage = '';
    }

    if (this.brwModel.BusinessName && this.brwModel.BusinessName.trim() != '' && this.brwModel.BusinessName.length < 3) {
      this.enableErrorMsg = true;
      this.ErrorMessage = 'Please enter a minimum of 3 characters in a field';
      return false;
    }

    if (this.brwModel.FirstName && this.brwModel.FirstName.trim() != '' && this.brwModel.FirstName.length < 3) {
      this.enableErrorMsg = true;
      this.ErrorMessage = 'Please enter a minimum of 3 characters in a field';
      return false;
    }

    if (this.brwModel.LastName && this.brwModel.LastName.trim() != '' && this.brwModel.LastName.length < 3) {
      this.enableErrorMsg = true;
      this.ErrorMessage = 'Please enter a minimum of 3 characters in a field';
      return false;
    }

    // validation call
    if (this.validateSearchInput()) {
      return false;
    }

    this.clearFtr = false;

    // set ABNumber property
    if (this.brwModel.ABNumber == null) {
      this.brwModel.ABNumber = 0;
    }

    // Api search call
    if (this.brwModel) {
      // set loader true
      this.loaderService.setLoaderStatus(true);
      this.subscription.push(this.commonService.getGrowerSearchApi(this.brwModel).subscribe(result => {
        this.clearFtr = true;
        // convert response in Model
        const apiRep = result as apiResponse;

        // if status is true
        if (apiRep && apiRep.status) {
          this.growerDS = [];
          const resultData = apiRep.resultData as any[];

          // check response data
          if (resultData && resultData.length > 0) {
            this.growerDS = this.convertToPass(resultData);
            this.ApiData = resultData;
          }
        }// displayed coutered error
        else if (apiRep && !apiRep.status) {
          this.toastrService.warning('Error: ' + apiRep.message);
        }
        // set loader false
        this.loaderService.setLoaderStatus(false);

        // enable add grower div at bottom
        this.enableAddGrower = true;
      }, error => LolLoggerService.error(error)));
    }
  }

  // event received from the custom table
  // Save grower returned from XSInc after searching grower
  saveSelectedGrower(e: any, searchForm: NgForm) {
    // Null check
    if (e.rowData) {
      // added
      const gmk = e.rowData.gmk;
      //
      const dataToAdd = this.ApiData.filter(x => x.gmk == gmk);

      // create data and format
      const data = {
        account: this.brwModel.ABNumber,
        companyCode: this.headerCompany,
        growerApiResult: dataToAdd[0]
      };

      // Added table's selected grower into the system
      this.subscription.push(this.commonService.AddToSystemGrower(data).subscribe(result => {
        // set growerDS  empty
        this.growerDS = [];

        // Set loader True on screen
        this.loaderService.setLoaderStatus(false);

        // get Added grower's GMK value
        const newGrowerGMK = +result;

        // value check
        if (newGrowerGMK != 0) {
          const newGrowerDetails =
          {
            account: this.brwModel.ABNumber,
            newGrower: newGrowerGMK
          };

          // check if component is not used through G2G order transfer
          if (!this.usedAsNestedComp) {
            this.sliderModelService.close();
          }
          // Set value on service to pass grower GMK number
          this.sliderModelService.gmkValue.next(newGrowerGMK);
          this.sliderModelService.growerProgramData.next([newGrowerDetails]);
          // reset search form
          searchForm.reset();
          // Set loader True off screen
          this.loaderService.setLoaderStatus(false);

          this.sliderModelService.newGrowerOrderSliderClose.next(false);
          // this.sliderModelService.GrowerSearchSliderActive.next(false);//Bug 48950 if user add a grower after search and come back to page again andsearch same data and select same grower the form was resetting also on close button slider was closing. this line fixes this issue.
        }
        else {
          // set error message
          this.toastrService.error('No record added to the system.');
        }
      }, error => LolLoggerService.error(error)));
    }
  }

  // show add grower form
  openAddGrowerModel(status) {
    // set add Grower component display true
    this.addGrower = status;
  }

  // Hiding Add grower from G2G transfer order
  hideAddGrower(e: any) {
    // set add grower false
    this.addGrower = false;
    // set add grower div at footer false
    this.enableAddGrower = false;
  }

  getGrowerSearchNotFoundMessage() {
    var searchType = '';
    if (this.growerSearchType == 'GP') {
      searchType = MasterConstants.MESSAGE_GROWER_SEARCH_NOT_FOUND_GP;
    }
    else if (this.growerSearchType == 'GOT') {
      searchType = MasterConstants.MESSAGE_GROWER_SEARCH_NOT_FOUND_GOT;
    }
    else if (this.growerSearchType == 'SRE') {
      searchType = MasterConstants.MESSAGE_GROWER_SEARCH_NOT_FOUND_SRE;
    }
    else if (this.growerSearchType == 'SCL') {
      searchType = MasterConstants.MESSAGE_GROWER_SEARCH_NOT_FOUND_SCL;
    }
    else if (this.growerSearchType == 'SAME_DEALER_TFR') {
      searchType = MasterConstants.MESSAGE_GROWER_SEARCH_NOT_FOUND_SAME_DEALER_TFR;
    }
    else if (this.growerSearchType == 'OTHER_DEALER_TFR') {
      searchType = MasterConstants.MESSAGE_GROWER_SEARCH_NOT_FOUND_OTHER_DEALER_TFR;
    }
    else {
      searchType = MasterConstants.MESSAGE_GROWER_SEARCH_NOT_FOUND_GOT;
    }

    if (searchType != '') {
      this.subscription.push(this.commonService.getMessageConfiguration(searchType).subscribe(result => {
        if (result) {
          var messageConfiguration = result as MessageConfigurationVM;
          this.growerSearchNotFoundMessage = messageConfiguration.message;
        }
      }, error => LolLoggerService.error(error)));
    }
    else {
      this.growerSearchNotFoundMessage = '';
    }
  }

  public stateSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.id.toLocaleLowerCase().indexOf(term) > -1
      || item.value.toString().toLocaleLowerCase().indexOf(term) > -1;
  }

  public clearFilter() {
    this.brwModel.BusinessName = '';
    this.brwModel.FirstName = '';
    this.brwModel.LastName = '';
    this.brwModel.GrowerCode = '';
    this.brwModel.GLN = '';
    this.brwModel.City = '';
    this.brwModel.State = '';
    this.growerDS = [];
  }
  // ngOnDestroy
  ngOnDestroy() {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // set page height
  setPageHeight() {
    const tableHeight = window.innerHeight - 65;
    $('.growerSearchModal').css('max-height', tableHeight + 'px');
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setPageHeight();
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setPageHeight();
  }

  public keyPressNumbers(event) {
    const numbers = /^[-+]?[0-9]+$/;
    if (!numbers.test(event.key)) {
      return false;
    }
  }
}
